import request from '@/utils/request'

let sso =process.env.VUE_APP_SSO_HOST


// 根据字典类型查询字典数据信息
export function getDicts(dictType) {
  return request({
    url: '/system/dict/data/type/' + dictType,
    method: 'get'
  })
}
// 首页项目查询
export function homeListPage(params) {
  return request({
    url: '/system/section/homeListPage' ,
    method: 'get',
    params:params
  })
}
// 我的问题里面项目查询
export function questionGetAuthSection(params) {
  return request({
    url: '/question/question/getAuthSection' ,
    method: 'get',
    params:params
  })
}
//认证
export function authorizationAuthenticate(data) {
  return request({
    url: '/web/authorization/authenticate' ,
    method: 'post',
    data:data
  })
}

// 供应商是否预警 
export function warningTime() {
  return request({
    url: '/web/book/warningTime' ,
    method: 'get',
  })
}
//新增投标授权委托书
export function PostWebBook(data) {
  return request({
    url: '/web/book' ,
    method: 'post',
    data:data
  })
}
//修改投标授权委托书
export function PutWebBook(data) {
  return request({
    url: '/web/book' ,
    method: 'put',
    data:data
  })
}
//查询投标授权委托书列表
export function webBookList() {
  return request({
    url: '/web/book/list' ,
    method: 'get',
  })
}

//指引操作
export function getInfo(query) {
  return request({
    url: sso+'/web/guides/getInfo',
    method: 'get',
    params: query
  })
}

//首次进入
export function getRead(query) {
  return request({
    url: sso+'/web/guides/read',
    method: 'get',
    params: query
  })
}